import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles} from '@material-ui/styles';
import { Button, Typography, Link } from '@material-ui/core';
import { PRODUCT_SHORT_NAME } from '../../constants';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  cookieLink: {
      color: '#23b9ea',
      fontWeight: 'bold',
      '&:hover': {
          color: '#26c9ff'
      },
      '&:focus': {
        color: '#26c9ff'
    },
  }
}));

const GDPR = props => {
  const { className, ...rest } = props;
  const expireGDPRInDays = 365;
  const expireReferrerInDays = 31;
  const cookieNameGDPR = `acceptedCookiesOn-${PRODUCT_SHORT_NAME}`;
  const cookieNameReferrer = `referrerURL-${PRODUCT_SHORT_NAME}`;
  const [acceptedCookies, setAcceptedCookies] = React.useState(false);
  const [mounted, setMounted] = React.useState(false);

  const classes = useStyles();

  const setCookie = (cookieName, expiresInDays, value, GDPR = false) => {

    const d = new Date();
    d.setTime(d.getTime() + (expiresInDays*24*60*60*1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cookieName}=${value};${expires};path=/`;
      if (GDPR) {
          setAcceptedCookies(true);
      }
  }

  const getCookie = (cookieName) => {
    var name = `${cookieName}=`;
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return false;
  }

  if( !mounted ) {
    setMounted(true);

    // get referrer

    let refCookieValue = getCookie(cookieNameReferrer);

    if(refCookieValue === false) {
        refCookieValue = document.referrer;
           if( refCookieValue === '') {
            refCookieValue = 'direct';  // default value;
            const urlParams = new URLSearchParams(window.location.search);
            const rParam = urlParams.get('referral');
            if (rParam ) {
                refCookieValue = rParam;
            }
        }
        setCookie(cookieNameReferrer, expireReferrerInDays, refCookieValue, false);
    }
    localStorage.setItem('referrerURL', refCookieValue);

    // do gdpr now
    setAcceptedCookies(getCookie(cookieNameGDPR) !== false);
  }

  if(acceptedCookies) {
      return null;
  }
  return (
    // <div className={clsx(classes.root, className)} >
    <div className={`gdprPanel`}>

    <table style={{margin: '12px auto'}}>
        <tr>
            <td style={{paddingRight: 12}}>
        Please note that our site uses cookies to improve and customize your experience.

Is it OK if we use cookies to optimize your experience? <br />
<b>Learn more by reviewing our <a href='/terms-and-conditions' target="_blank" className={classes.cookieLink}>Policies</a>.</b>
        </td>
        <td className='gdprButtonCell'>
    <Button
        variant='contained'
        color='primary'
        size='small'
        onClick={() => {setCookie(cookieNameGDPR, expireGDPRInDays, new Date().toISOString(), true)}}
    >
        Yes, it's OK
    </Button>
    </td>
    </tr>
    </table>
    </div>
  );
};

GDPR.propTypes = {
  className: PropTypes.string
};

export default GDPR;
